import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    { //登录
        path: '/login',
        name: 'login',
        component: resolve => require(['./page/login.vue'],resolve),
    },
    { //商品
        path: '/goods',
        name: 'goods',
        component: resolve => require(['./page/goods.vue'],resolve),
    },
    { //首页
        path: '/home',
        name: 'home',
        component: resolve => require(['./page/home.vue'],resolve),
    },
    { //数据字典
        path: '/dict',
        name: 'dict',
        component: resolve => require(['./page/dict.vue'],resolve),
    },
    { //报表管理
        path: '/report',
        name: 'report',
        component: resolve => require(['./page/report.vue'],resolve),
    },
    { //标签管理
        path: '/label',
        name: 'label',
        component: resolve => require(['./page/label.vue'],resolve),
    },
    { //文章管理
        path: '/essay/:type/:id',//0商家 1 商品
        name: 'essay',
        component: resolve => require(['./page/essay.vue'],resolve),
    },
    { //菜单管理
        path: '/menu',
        name: 'menu',
        component: resolve => require(['./page/menu.vue'],resolve),
    },
    { //订单管理
        path: '/order',
        name: 'order',
        component: resolve => require(['./page/order.vue'],resolve),
    },
    { //送货管理
        path: '/delivery',
        name: 'delivery',
        component: resolve => require(['./page/delivery.vue'],resolve),
    },
    { //送货单打印
        path: '/print/:delId',
        name: 'print',
        component: resolve => require(['./page/print.vue'],resolve),
    },
    { //送货单打印
        path: '/ztd/:id',
        name: 'ztd',
        component: resolve => require(['./page/ztd.vue'],resolve),
    },
    { //用户管理
        path: '/customer',
        name: 'customer',
        component: resolve => require(['./page/customer.vue'],resolve),
    },
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    console.log('**********change route**********');
    console.log(to);
    let toName = to.name;
    let toPath = to.path;
    if (toName == 'login') {//登录界面
        if (localStorage.token) {//已经登录的
            sessionStorage.hasBar = 1;
            let path = '/goods';
            sessionStorage.toPath = path;
            next({path});
        } else {
            sessionStorage.hasBar = 0;
            next();
        }
    }else{//非登录界面
        if (localStorage.token) {//已登录
            if(!toName){//没有定义的路由
                sessionStorage.hasBar = 1;
                sessionStorage.toPath = '/goods';
                return next({path:'/goods'});
            }
            if(['essay','print','ztd'].indexOf(toName) > -1){
                sessionStorage.hasBar = 0;
            }else sessionStorage.hasBar = 1;
            sessionStorage.toPath = toPath;
            next();
        }else {
            sessionStorage.hasBar = 0;
            next({path: '/login'});
        }
    }
})

export default router;